export default __webpack_public_path__ + "static/media/grp1_w320.98d38beb.jpeg";